import _objectSpread from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _defineProperty from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { useCallback, useEffect, useState } from 'react';
import classnames from 'classnames';
import { Button, CircularProgress, DialogActions, DialogContent, IconButton, InputAdornment, Popover } from '@material-ui/core';
import { Clear, DateRange as DateRangeIcon } from '@material-ui/icons';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import format from 'date-fns/format';
import parse from 'date-fns/parse';
import isValid from 'date-fns/isValid';
import isSameDay from 'date-fns/isSameDay';
import isWithinInterval from 'date-fns/isWithinInterval';
import isBefore from 'date-fns/isBefore';
import isAfter from 'date-fns/isAfter';
import startOfDay from 'date-fns/startOfDay';
import isUndefined from 'lodash/isUndefined';
import isArray from 'lodash/isArray';
import isObject from 'lodash/isObject';
import { FieldType } from '../Form.models';
import TextField from './Text';
import DateFnsUtils from '@date-io/date-fns';
import ruLocale from 'date-fns/locale/ru';
import { renderDatePickerToolbar } from './Date';
import { findDOMNode } from 'react-dom';
var stringFormat = 'dd.MM.yyyy';
/**
 * Преобразовывает в массив дат
 * @param inputValue
 */

var formatToDatesArray = function formatToDatesArray(inputValue) {
  var values = !inputValue ? [undefined, undefined] : [inputValue.from || undefined, inputValue.to || undefined];

  if (values.length === 1) {
    values.push(undefined);
  }

  return values.map(function (value) {
    if (!value) {
      return undefined;
    }

    var formattedValue = parse(value, stringFormat, new Date());
    return isValid(formattedValue) ? formattedValue : undefined;
  });
};
/**
 * Преобразовывает в объект дат
 * @param inputValue
 */


var formatToDatesObject = function formatToDatesObject(inputValue) {
  var values = isArray(inputValue) ? inputValue.map(function (value) {
    return value ? format(value, stringFormat) : '';
  }) : inputValue.split('-');

  if (!values[0] && !values[1]) {
    return undefined;
  }

  return {
    from: values[0],
    to: values[1] || undefined
  };
};
/**
 * Преобразовывает в строку дат
 * @param dates
 */


var formatToDatesString = function formatToDatesString(dates) {
  if (!dates) {
    return '';
  } else if (isArray(dates)) {
    var _dates = _slicedToArray(dates, 2),
        start = _dates[0],
        end = _dates[1];

    return "".concat(start ? format(start, 'dd.MM.yyyy') : '').concat(end ? '-' : '').concat(end ? format(end, 'dd.MM.yyyy') : '');
  } else if (isObject(dates) && dates.hasOwnProperty('from') && dates.hasOwnProperty('to')) {
    var from = dates.from,
        to = dates.to;
    return "".concat(from ? from : '').concat(to ? '-' : '').concat(to ? to : '');
  }
};

var minDate = new Date('1800-01-01');
var maxDate = new Date('2100-01-01');

var validate = function validate(values, params) {
  if (typeof values === 'string') {
    var min = params.min,
        max = params.max;
    var dates = values.split('-');

    if (dates.length > 1) {
      var from = parse(dates[0], stringFormat, new Date());
      var to = parse(dates[1], stringFormat, new Date());

      if (isValid(from) && isValid(to) && isBefore(to, from)) {
        return ['Вторая дата не может быть раньше первой'];
      } else if (!isValid(from)) {
        return ['Не указана первая дата'];
      }
    }

    return dates.map(function (date, index) {
      var formattedDate = parse(date, 'dd.MM.yyyy', new Date());
      var formattedMinDate = startOfDay(min || minDate);
      var formattedMaxDate = startOfDay(max || maxDate);

      if (!isValid(formattedDate)) {
        return date !== '' ? "\u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0439 \u0444\u043E\u0440\u043C\u0430\u0442 ".concat(index ? 'второй' : 'первой', " \u0434\u0430\u0442\u044B") : undefined;
      } else if (isBefore(formattedDate, formattedMinDate)) {
        return "\u0414\u0430\u0442\u0430 \u043D\u0435 \u0434\u043E\u043B\u0436\u043D\u0430 \u0431\u044B\u0442\u044C \u043C\u0435\u043D\u044C\u0448\u0435 ".concat(format(formattedMinDate, 'dd.MM.yyyy'));
      } else if (isAfter(formattedDate, formattedMaxDate)) {
        return "\u0414\u0430\u0442\u0430 \u043D\u0435 \u0434\u043E\u043B\u0436\u043D\u0430 \u0431\u044B\u0442\u044C \u0431\u043E\u043B\u044C\u0448\u0435 ".concat(format(formattedMaxDate, 'dd.MM.yyyy'));
      } else {
        return undefined;
      }
    }).filter(function (error) {
      return !isUndefined(error);
    });
  }

  return ['Неверный формат даты'];
};

var inputRef = React.createRef();

function DateRangeComponent(props) {
  var _classnames7;

  var id = props.id,
      field = props.field,
      value = props.value,
      onFieldChange = props.onFieldChange,
      classes = props.classes,
      slim = props.slim,
      disabled = props.disabled;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      opened = _useState2[0],
      setOpened = _useState2[1]; // модалка


  var _useState3 = useState(undefined),
      _useState4 = _slicedToArray(_useState3, 2),
      componentError = _useState4[0],
      setComponentError = _useState4[1]; // текст ошибки


  var _useState5 = useState(formatToDatesString(value)),
      _useState6 = _slicedToArray(_useState5, 2),
      inputValue = _useState6[0],
      setInputValue = _useState6[1]; // значение поля ввода


  var _useState7 = useState(formatToDatesArray(value)[0]),
      _useState8 = _slicedToArray(_useState7, 2),
      from = _useState8[0],
      setFrom = _useState8[1]; // дата С


  var _useState9 = useState(formatToDatesArray(value)[1]),
      _useState10 = _slicedToArray(_useState9, 2),
      to = _useState10[0],
      setTo = _useState10[1]; // дата По


  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      anchorEl = _React$useState2[0],
      setAnchorEl = _React$useState2[1];

  var min = minDate,
      max = maxDate;

  if (field.params && field.params.date) {
    if (field.params.date.min) {
      min = field.params.date.min;
    }

    if (field.params.date.max) {
      max = field.params.date.max;
    }
  }

  var ID = id || field.name;
  useEffect(function () {
    setInputValue(formatToDatesString(value));
    setFrom(formatToDatesArray(value)[0]);
    setTo(formatToDatesArray(value)[1]);
  }, [value]);
  /**
   * Изменение даты в поле ввода
   * @param id
   * @param values
   */

  var onChangeInputValue = function onChangeInputValue(id, values) {
    var errors = validate(values, {
      min: min,
      max: max
    });
    setComponentError(errors.length > 0 ? errors[0] : '');
    var datesObject = formatToDatesObject(values);
    onFieldChange(id, datesObject);
    setInputValue(values);

    if (errors.length === 0) {
      setFrom(formatToDatesArray(datesObject)[0]);
      setTo(formatToDatesArray(datesObject)[1]);
    }
  };
  /**
   * Изменение даты в календаре
   */


  var onChangeFromDate = function onChangeFromDate(date) {
    setFrom(to && isAfter(date, to) ? to : date);
  };
  /**
   * Изменение даты в календаре
   */


  var onChangeToDate = function onChangeToDate(date) {
    setTo(from && isBefore(date, from) ? from : date);
  };
  /**
   * Рендер дат календаря
   */


  var renderFromDates = useCallback(function (date, selectedDate, dayInCurrentMonth) {
    var start = from;
    var end = to;
    var dayIsBetween = false;
    var isOneDay = false;
    var isDisabled = false;
    var wrapperClassName = '';
    var dayClassName = '';

    if (start && end) {
      var _classnames, _classnames2;

      dayIsBetween = isWithinInterval(date, {
        start: start,
        end: end
      });
      isOneDay = isSameDay(date, start) || isSameDay(date, end);
      isDisabled = !isOneDay && isAfter(date, end);
      wrapperClassName = classnames((_classnames = {}, _defineProperty(_classnames, classes.highlight, dayIsBetween), _defineProperty(_classnames, classes.firstHighlight, isSameDay(date, start)), _defineProperty(_classnames, classes.endHighlight, isSameDay(date, end)), _classnames));
      dayClassName = classnames((_classnames2 = {}, _defineProperty(_classnames2, classes.highlightNonCurrentMonthDay, !dayInCurrentMonth && dayIsBetween), _defineProperty(_classnames2, classes.oneDayHighlight, isOneDay), _classnames2));
    } else if (start) {
      dayClassName = classnames(_defineProperty({}, classes.oneDayHighlight, isSameDay(date, start)));
    } else if (end) {
      isDisabled = !isSameDay(date, end) && isAfter(date, end);
    }

    return React.createElement("div", {
      className: wrapperClassName
    }, React.createElement(IconButton, {
      className: classnames(classes.day, dayClassName),
      disabled: !dayInCurrentMonth || isDisabled
    }, React.createElement("span", null, " ", format(date, 'd'), " ")));
  }, [from, to]);
  /**
   * Рендер дат календаря
   */

  var renderToDates = useCallback(function (date, selectedDate, dayInCurrentMonth) {
    var start = from;
    var end = to;
    var dayIsBetween = false;
    var isOneDay = false;
    var isDisabled = false;
    var wrapperClassName = '';
    var dayClassName = '';

    if (start && end) {
      var _classnames4, _classnames5;

      dayIsBetween = isWithinInterval(date, {
        start: start,
        end: end
      });
      isOneDay = isSameDay(date, start) || isSameDay(date, end);
      isDisabled = !isOneDay && isBefore(date, start);
      wrapperClassName = classnames((_classnames4 = {}, _defineProperty(_classnames4, classes.highlight, dayIsBetween), _defineProperty(_classnames4, classes.firstHighlight, isSameDay(date, start)), _defineProperty(_classnames4, classes.endHighlight, isSameDay(date, end)), _classnames4));
      dayClassName = classnames((_classnames5 = {}, _defineProperty(_classnames5, classes.highlightNonCurrentMonthDay, !dayInCurrentMonth && dayIsBetween), _defineProperty(_classnames5, classes.oneDayHighlight, isOneDay), _classnames5));
    } else if (end) {
      dayClassName = classnames(_defineProperty({}, classes.oneDayHighlight, isSameDay(date, end)));
    } else if (start) {
      isDisabled = !isSameDay(date, start) && isBefore(date, start);
    }

    return React.createElement("div", {
      className: wrapperClassName
    }, React.createElement(IconButton, {
      disabled: !dayInCurrentMonth || isDisabled,
      className: classnames(classes.day, dayClassName)
    }, React.createElement("span", null, " ", format(date, 'd'), " ")));
  }, [from, to]);
  /**
   * Закрытие модалки
   */

  var close = function close() {
    setOpened(false);
    setAnchorEl(null);
  };
  /**
   * Открытие модалки
   */


  var open = function open() {
    setOpened(true);
    setAnchorEl(findDOMNode(inputRef.current));
  };
  /**
   * Очистка значения
   */


  var clear = function clear() {
    onFieldChange(ID, undefined);
    setInputValue('');
    setFrom(undefined);
    setTo(undefined);
  };
  /**
   * Сохранение значения
   */


  var save = function save() {
    var values = formatToDatesString([from, to]);
    var errors = validate(values, {
      min: min,
      max: max
    });
    setComponentError(errors.length > 0 ? errors[0] : '');
    var datesObject = formatToDatesObject(values);

    if (errors.length === 0) {
      onFieldChange(id, datesObject);
      setInputValue(values);
    }

    close();
  };
  /**
   * Потеря фокуса
   */


  var onBlur = function onBlur() {
    save();
  };

  var mask = {
    value: '99.99.9999-99.99.9999'
  };
  var InputProps = {
    type: 'text',
    ref: inputRef,
    endAdornment: React.createElement(InputAdornment, {
      position: 'end'
    }, React.createElement(IconButton, {
      "aria-label": "\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u0432\u044B\u0431\u043E\u0440 \u0434\u0430\u0442",
      onClick: open,
      disabled: disabled,
      size: slim ? 'small' : 'medium'
    }, React.createElement(DateRangeIcon, {
      fontSize: slim ? 'small' : 'default'
    }))),
    onBlur: onBlur
  };

  var fieldProps = _objectSpread({}, props, {
    field: _objectSpread({}, field, {
      type: FieldType.Text
    }),
    value: inputValue
  });

  return React.createElement("div", null, React.createElement(TextField, Object.assign({}, fieldProps, {
    error: props.error || componentError,
    mask: mask,
    onFieldChange: onChangeInputValue,
    InputProps: InputProps
  })), value && React.createElement(IconButton, {
    className: classnames(classes.clearButton, classes.dateClearButton, (_classnames7 = {}, _defineProperty(_classnames7, classes.clearButtonSlim, slim), _defineProperty(_classnames7, classes.dateClearButtonSlim, slim), _classnames7)),
    size: slim ? 'small' : 'medium',
    "aria-label": "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C \u043F\u043E\u043B\u0435",
    onClick: clear,
    disabled: disabled
  }, React.createElement(Clear, {
    fontSize: slim ? 'small' : 'default'
  })), opened && React.createElement(Popover, {
    open: true,
    onClose: close,
    anchorEl: anchorEl,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'left'
    }
  }, React.createElement(DialogContent, {
    className: classes.pickerWrapper
  }, React.createElement("div", {
    className: classes.picker
  }, React.createElement(MuiPickersUtilsProvider, {
    utils: DateFnsUtils,
    locale: ruLocale
  }, React.createElement("div", {
    className: classes.calendars
  }, React.createElement(DatePicker, {
    variant: 'static',
    value: from || null,
    onChange: onChangeFromDate,
    renderDay: renderFromDates,
    minDate: min,
    maxDate: to || max,
    ToolbarComponent: renderDatePickerToolbar({
      classes: classes,
      beforeText: 'с'
    })
  }), React.createElement(DatePicker, {
    variant: 'static',
    value: to || null,
    onChange: onChangeToDate,
    renderDay: renderToDates,
    minDate: from || min,
    maxDate: max,
    ToolbarComponent: renderDatePickerToolbar({
      classes: classes,
      beforeText: 'по'
    })
  }))))), React.createElement(DialogActions, {
    className: classes.pickerBtns
  }, React.createElement(Button, {
    onClick: clear,
    color: 'primary'
  }, "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C"), React.createElement(Button, {
    onClick: close,
    color: 'primary'
  }, "\u041E\u0442\u043C\u0435\u043D\u0430"), React.createElement(Button, {
    onClick: save,
    color: 'primary',
    autoFocus: true
  }, "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C"))));
}

var DateRange = function DateRange(props) {
  var classes = props.classes,
      validation = props.validation,
      slim = props.slim;
  return React.createElement("div", {
    className: classes.fieldContainer
  }, React.createElement(DateRangeComponent, Object.assign({}, props)), validation && React.createElement("div", {
    className: classes.fieldLoaderContainer
  }, React.createElement(CircularProgress, {
    className: classnames(classes.fieldLoader, _defineProperty({}, classes.slimFieldLoader, !!slim)),
    size: slim ? 16 : 24,
    thickness: 4
  })));
};

export default DateRange;